import { render, staticRenderFns } from "./PaymentShopBindSetting.vue?vue&type=template&id=0ec88f15&"
import script from "./PaymentShopBindSetting.vue?vue&type=script&lang=js&"
export * from "./PaymentShopBindSetting.vue?vue&type=script&lang=js&"
import style0 from "./PaymentShopBindSetting.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports